<template>
  <div>
    <HeaderBar />
    <div class="px-1 mt-4 mb-4">
      <div class="dataUploadTitle mt-5">Ingreso por producto</div>
      <div>
        <validation-observer ref="GanForm">
          <b-form class="auth-register-form" @submit.prevent="">
            <b-form-group class="datePicker" label="Fecha">
              <validationProvider #default="{ errors }" name="Fecha" rules="required">
                <b-form-datepicker v-model="economic.date"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :min="minCfgDate"
                  :max="maxCfgDate" locale="es-ES" class="form-control" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validationProvider>
            </b-form-group>
            <b-form-group label="Tipo de producto" label-for="productType" class="pt-0">
              <validationProvider #default="{ errors }" name="Producto" rules="required">
                <b-form-select id="productType" ref="Proddescription" v-model="economic.product_type"
                  :options="productTypeOptions" :values="productTypeOptions.value" label="text" @change="changeText" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validationProvider>
            </b-form-group>
            <div class="d-flex justify-content-end mb-1">
              <b-button class="bg-primary dataButton d-flex px-1 py-0 align-items-center justify-content-center"
                @click="addIncome">
                <div>Agregar</div>
                <div class="" style="color: #d7b92c">
                  <feather-icon icon="PlusIcon" size="20" />
                </div>
              </b-button>
            </div>
            <div class="d-flex justify-content-between">
              <b-table striped hover bordered :items="items" :fields="fields" responsive>
                <template #cell(description)="data">
                  <validation-provider #default="{ errors }" name="Descripción" rules="required">
                    <b-form-input type="text" :value="data.value"
                      v-model="items[data.index].description"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </template>
                <template #cell(quantity)="data">
                  <validation-provider #default="{ errors }" name="Cantidad" rules="required">
                    <b-form-input type="number" :value="data.value" v-model="data.item.quantity"
                      @change="data.item.total = calcValues(data.item.quantity, data.item.amount, data.index)"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </template>
                <template #cell(amount)="data">
                  <validation-provider #default="{ errors }" name="Precio Unitario" rules="required">
                    <b-form-input type="number" :value="data.value" v-model="data.item.amount"
                      @change="data.item.total = calcValues(data.item.quantity, data.item.amount, data.index)"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </template>
                <template #cell(total)="data">
                  <b-form-input type="number" :value="data.value" v-model="data.item.total"
                    readonly="readonly"></b-form-input>
                </template>
                <template #cell(action)="data">
                  <b-button class="delete-button" variant="danger" @click="delIncome(data.index)">Eliminar</b-button>
                </template>
              </b-table>
            </div>

            <div class="d-flex justify-content-between">
              <b-form-group label=" Total" label-for="total" class="mr-1 w-50">
                <validation-provider #default="{ errors }" name="reason">
                  <b-form-input id="total" v-model="Grandtotal" class="w-100" :state="errors.length > 0 ? false : null"
                    name="total" readonly="readonly" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label=" # de Comprobante" label-for="voucher" class="mr-1 w-50">
                <validation-provider #default="{ errors }" name="Voucher">
                  <b-form-input id="voucher" v-model="economic.number" class="w-100"
                    :state="errors.length > 0 ? false : null" name="voucher" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>
            <div class="d-flex flex-column align-items-center justify-content-center mb-4 pb-4">
              <!-- <div>
                    <b-img src="@/assets/images/ganImage/UpoladImage.png"></b-img>
                  </div> -->

              <b-button @click="insertIncome"
                class="bg-primary dataButton d-flex align-items-center justify-content-center w-100 mb-4">
                <div class="ml-3">Cargar Ingreso</div>
                <div class="ml-3" style="color: #d7b92c">
                  <feather-icon icon="PlusIcon" size="20" />
                </div>
              </b-button>

            </div>
            <!-- <b-modal class="modal-lg" centered v-model="modalShow" hide-footer hide-header>
                  <div class="d-flex  align-items-end justify-content-end">
                    <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
                  </div>
                  <div class="d-flex flex-column align-items-center justify-content-center">
                    <b-form-group label="Lugar de Venta" label-for="salesPlace">
                      <validation-provider #default="{ errors }" name="salesPlace" vid="salesPlace"
                        rules="required|salesPlace">
                        <b-form-input id="salesPlace" :state="errors.length > 0 ? false : null"
                          name="salesPlace" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-button class="bg-primary mt-2 mb-2" block>Incluir Evento</b-button>
                  </div>
                </b-modal> -->
          </b-form>
        </validation-observer>
      </div>
      <ControlMenu />
    </div>
  </div>
</template>

<script>
import ControlMenu from "@/components/ControlMenu.vue";
import HeaderBar from '@/components/HeaderBar.vue'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BTable,
  BRow,
  BCol,
  BFormDatepicker,
  BFormTextarea,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BForm,
  BImg,
  BButton,
  BFormCheckbox,
  BModal,
} from "bootstrap-vue";
import axios from 'axios'
import { required } from "@validations";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    ControlMenu,
    HeaderBar,
    flatPickr,
    BModal,
    BFormGroup,
    BFormSelect,
    ValidationProvider,
    BFormDatepicker,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BForm,
    required,
    vSelect,
    BTable,
    BImg,
    BButton,
    BFormCheckbox,
    BFormTextarea,
  },

  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 200)
    minDate.setDate(15)
    // 15th in two months
    const maxDate = new Date(today)
    maxDate.setMonth
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(maxDate.getDate())
    return {
      maxCfgDate: maxDate,
      minCfgDate: minDate,
      description: "",
      date: null,
      dateDefault: null,
      timePicker: null,
      datetime: null,
      multiDate: null,
      productType: "",
      productTypeOptions: [],
      fields: [
        {
          key: 'description',
          label: 'Producto'
        },
        {
          key: 'quantity',
          label: 'Cantidad'
        },
        {
          key: 'amount',
          label: 'Unitario'
        },
        {
          key: 'total',
          label: 'Total'
        },
        {
          key: 'action',
          label: ''
        },
      ],
      items: [],
      Grandtotal: 0,
      economic: {
        date: today,
        description: null,
        farm_id: localStorage.getItem('currentFarm'),
        number: null,
        product_type: 0,
        income_id: 0,
      },
    };
  },
  methods: {
    async fetcProducts(config) {
      fetch(this.$apiUrl + "list/products_types", config)
        .then(response => response.json())
        .then(result => {
          console.log(result.products_types);
          this.productTypeOptions = result.products_types.map(item => { return { value: item.id, text: item.name } })
        })
    },

    addIncome() {
      let single = {
        product_type: this.economic.product_type,
        income_id: 0,
        description: null,
        quantity: 0,
        amount: 0,
        total: 0,
      }
      console.log("incomes_detail ", this.items);
      this.items.push(single);
    },

    delIncome(index) {
      this.items = this.items.filter((item, i) => i !== index);
      this.$emit('input', this.items);
    },

    async insertIncome() {
      try {
        const success = await this.$refs.GanForm.validate();
        if (success) {
          const token = localStorage.getItem("accessToken");
          const config = { headers: { "X-Authorization": `Bearer ${token}` } };
          let incomeId = 0;

          console.log("Incomes master items", this.economic);
          // Enviar el primer request para "incomes_master"
          const result = await this.$http.post("add/incomes_master", this.economic, config);
        

          incomeId = result.data.incomes_master.id;
          /* this.economic = {
            date: null,
            description: null,
            farm_id: localStorage.getItem('currentFarm'),
            number: null,
            product_type: 0,
            income_id: 0,
          }; */

          // Configurar cada elemento en this.items con income_id y total
          this.items.forEach(element => {
            element.income_id = incomeId;
            element.total = element.quantity * element.amount;
            element.product_type= this.economic.product_type;
          });

          console.log("incomes_detail items", this.items);

          // Enviar los requests en paralelo para "incomes_detail"
          const requests = this.items.map(items => this.$http.post("add/incomes_detail", items, config));
          await axios.all(requests);

          // Mostrar mensaje de éxito
          this.$swal({
            title: 'Registro de Productos',
            text: 'Se insertaron los productos de manera satisfactoria',
            type: 'success',
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#5E8F23',
            showCloseButton: true,
            showLoaderOnConfirm: false
          }).then(() => {
            history.back();
          });
        }
      } catch (error) {
        console.error("Error en el proceso de inserción:", error);
        this.$swal({
          title: 'Error',
          text: 'Ocurrió un error durante la inserción de los productos. Por favor, inténtalo nuevamente.',
          type: 'error',
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          showCloseButton: true
        });
      }
    },


    calcValues(qty, amnt, index) {
      console.log(qty * amnt)
      this.items[index].total = qty * amnt;
      let gTotal = 0;
      this.items.forEach(function (row) {
        gTotal = gTotal + row.total
      });
      this.Grandtotal = gTotal;
      return (qty * amnt);
    },
    changeText(e) {
      console.log(e);
      let self = this;
      this.productTypeOptions.filter(function (row) {
        if (row.value == e) {
          self.economic.description = row.text;
          console.log(self.economic.description)
        }
      })
    }
  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = { headers: { "X-Authorization": `Bearer ${token}` } };
    this.fetcProducts(config);
  },
};
</script>

<style lang="scss">
.dataUploadTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  color: #5e5873;
}

table {
  width: 100% !important;
  //height: 400px;
  max-height: 400px;
}

@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/pages/page-auth.scss";
</style>
